import { render, staticRenderFns } from "./pricingarea.vue?vue&type=template&id=a2e34a2c&scoped=true"
import script from "./pricingarea.vue?vue&type=script&lang=js"
export * from "./pricingarea.vue?vue&type=script&lang=js"
import style0 from "./pricingarea.vue?vue&type=style&index=0&id=a2e34a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e34a2c",
  null
  
)

export default component.exports